import CryptoJS from 'crypto-js';
import { v4 as uuidv4 } from 'uuid';
import defaultSettings from '../../config/defaultSettings';
import { API_CONFIG } from '../../config/env';


// 生成uuid
export const createStandardUuid = () => {
  return uuidv4();
}
export const getCurrentDate = () => {
  const date = new Date();
  const year = date.getFullYear();
  const month = date.getMonth() + 1;
  const day = date.getDate();
  const weekday = date.getDay();
  return `${year}年${month}月${day}日 星期${weekday}`;
}
// 获取当前时间戳
// 获取当前时间，返回 yyyy-mm-dd hh:mm:ss 格式
export const getTime = () => {
  const date = new Date();
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  const hours = String(date.getHours()).padStart(2, '0');
  const minutes = String(date.getMinutes()).padStart(2, '0');
  const seconds = String(date.getSeconds()).padStart(2, '0');
  return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
}
// 生成随机字符串
export const generateRandomString = (length = 16) => {
  const characters = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
  let result = '';
  for (let i = 0; i < length; i++) {
    const randomIndex = Math.floor(Math.random() * characters.length)
    result += characters[randomIndex];
  }
  return result;
}
// aes加密
export const aesEncrypt = (data) => {
  let key = CryptoJS.enc.Utf8.parse(defaultSettings.aes_key)
  let iv = CryptoJS.lib.WordArray.random(16)
  let encrypted = CryptoJS.AES.encrypt(data, key, {
    iv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7
  })
  return CryptoJS.enc.Base64.stringify(iv) +'|'+ encrypted.toString()
}
// aes解密
export const aesDecrypt = (params) => {
  let paramsArr = params.split("|")
  // 秘钥,转换成utf8格式字符串，用于加密解密，一般长度是16位（由后端提供）
  let key = CryptoJS.enc.Utf8.parse(defaultSettings.aes_key)
  // 偏移量，转换成utf8格式字符串，一般长度是16位(由后端提供)
  let iv = CryptoJS.enc.Base64.parse(paramsArr[0])
  let decrypt = CryptoJS.AES.decrypt(paramsArr[1], key, {
    iv,							// 偏移量
    mode: CryptoJS.mode.CBC,		// 模式（五种加密模式，各有优缺）
    padding: CryptoJS.pad.Pkcs7	// 填充
  })
  // 转成utf8格式字符串，并返回出去
  let decryptedStr = decrypt.toString(CryptoJS.enc.Utf8)
  return decryptedStr
}
// 构造待签名字符串（MD5 / SHA256 两版共用，确保签名规则完全一致）
// 规则：键名升序 → 跳过 sign 字段与空值 → 对象/数组序列化为 JSON → 用 '&' 连接
//       sha256 不追加 signKey，其余算法在末尾追加 signKey（末尾不会残留 '&'）
const buildSignString = (data, type) => {
  const sortedKeys = Object.keys(data).sort();
  // 用数组收集后用 & 连接，避免逐项累加 '=' + '&' 导致末尾残留分隔符
  const arr = []
  for (let index = 0; index < sortedKeys.length; index++) {
    const key = sortedKeys[index];
    let val = data[key];
    // 跳过 sign 字段、空值、以及空对象字面量
    if (!val || key === 'sign' || val === '{}') {
      continue
    }
    // 对象 / 数组统一序列化为 JSON 字符串，避免直接拼接成 [object Object]
    if (typeof val === 'object') {
      // 空对象、空数组不参与签名
      if (Object.keys(val).length === 0) {
        continue
      }
      val = JSON.stringify(val)
    }
    arr.push(key + '=' + val)
  }
  const str = arr.join('&')
  // sha256 不追加 signKey，其余算法在末尾追加
  if (type == 'sha256') {
    return str
  }
  return str ? str + '&signKey=' + defaultSettings.sign_key : 'signKey=' + defaultSettings.sign_key
}

// 数据签名（MD5）
export const dataSign = (data, type = 'md5') => {
  const str = buildSignString(data, type)
  console.log('dataSignstr', str)
  return CryptoJS.MD5(str).toString()
}
// 注：历史实现（arr.join("&") + "&signKey=" 拼接）已被上方 buildSignString 取代，
// 其「对象序列化 + 空对象跳过」逻辑已合并进新实现，此处不再保留。

// ==================== SHA256 版请求签名 ====================
// 对齐后端 makeSign() 实现：
//   sha256 分支 → hash_hmac('sha256', implode("&", $arr), SIGN_KEY)：参数串不含 signKey
//   md5    分支 → md5(implode("&", $arr) . "&signKey=" . SIGN_KEY)：参数串末尾追加 signKey
// 两个分支的「参数串是否追加 signKey」由 buildSignString 的 type 分支控制，已与后端一致。

// 数据签名（SHA256 / HMAC-SHA256）
// 后端实现为 hash_hmac('sha256', 参数串, SIGN_KEY)，即「密钥参与运算」的 HMAC-SHA256，
// 而非对「参数串 + signKey」做普通 SHA256 摘要。因此：
//   1. 必须使用 CryptoJS.HmacSHA256，不能用 CryptoJS.SHA256（二者结果完全不同）；
//   2. 密钥以 HMAC key 传入，参数串中不再追加 signKey（由 buildSignString 的 type 分支控制）。
// 后端 md5 分支仍为 md5(参数串 . "&signKey=" . SIGN_KEY)，故 MD5 版保持原样。
export const dataSignSha256 = (data, type = 'sha256') => {
  const str = buildSignString(data, type)
  console.log('dataSignSha256str', str)
  return CryptoJS.HmacSHA256(str, defaultSettings.sign_key).toString()
}

// 公共请求字段（time / nonce_str / message_id / client_id / data / sign）
export const buildBaseRequestSha256 = (extra = {}) => {
  return {
    time: getTime(),
    nonce_str: generateRandomString(16),
    message_id: createStandardUuid(),
    client_id: localStorage.getItem('uuid') || createStandardUuid(),
    data: '',
    sign: '',
    ...extra,
  }
}

// 通用请求体包装（SHA256 签名），对应 httpRequest.ts 的 objData
export const objDataSha256 = (data, encryptBool) => {
  const shouldEncrypt = encryptBool !== undefined ? encryptBool : API_CONFIG.encrypt;
  if (!shouldEncrypt) {
    return data ? data : null;
  }
  const requestData = buildBaseRequestSha256();
  requestData.data = data ? aesEncrypt(JSON.stringify(data)) : null;
  requestData.sign = dataSignSha256(requestData);
  return requestData
}

// 上传请求体包装（SHA256 签名，is_encrypt=1），对应 uploadHttpRequest.ts 的 upLoadObjData
// 注意：data 直接透传、不做 JSON.stringify，与原 MD5 版保持字节级一致，
// 否则签名串中 data 段的取值会与原实现不同，导致后端验签失败。
export const upLoadObjDataSha256 = (data) => {
  const requestData = buildBaseRequestSha256({ is_encrypt: 1 });
  requestData.data = data;
  requestData.sign = dataSignSha256(requestData);
  return requestData
}

// 计算文件 SHA256 摘要
// 说明：上传接口的字段名仍为 md5 / chunk_md5（保持不变），
//       仅将摘要算法由 MD5 更换为 SHA256，后端校验时需同步使用 SHA256。
// 优先使用浏览器原生 Web Crypto（性能远优于纯 JS 实现）；
// 非安全上下文（https / localhost 之外）crypto.subtle 不可用，降级为 crypto-js。
export const calculateFileSha256 = (file) => {
  // 兼容上传组件包装后的文件对象（如 Element Plus 的 { raw }）
  const actualFile = file?.raw || file;
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onerror = () => reject(reader.error);
    reader.onload = async (e) => {
      const buffer = e.target?.result;
      if (!buffer) {
        reject(new Error('文件读取失败'));
        return;
      }
      try {
        if (globalThis.crypto?.subtle?.digest) {
          const digest = await globalThis.crypto.subtle.digest('SHA-256', buffer);
          const hashHex = Array.from(new Uint8Array(digest))
            .map((b) => b.toString(16).padStart(2, '0'))
            .join('');
          resolve(hashHex);
          return;
        }
      } catch (err) {
        console.warn('Web Crypto 计算 SHA256 失败，降级为 crypto-js', err);
      }
      try {
        const wordArray = CryptoJS.lib.WordArray.create(new Uint8Array(buffer));
        resolve(CryptoJS.SHA256(wordArray).toString());
      } catch (err) {
        reject(err);
      }
    };
    reader.readAsArrayBuffer(actualFile);
  });
}
